<router-outlet> </router-outlet>
<div class="build-info text-center">
  TrustArc Authentication and Authorization Service {{ systemInfo }}
</div>

<p-toast position="top-center" />

<p-confirmDialog
  icon="pi pi-exclamation-triangle"
  appendTo="body"
  rejectButtonStyleClass="p-button-text"
/>
